import React from "react";
import { makeStyles } from "@material-ui/core";
let responsiveLength = "1000";

let useStyles = makeStyles((theme) => ({
    root: {
        ...theme.grid.gridMdContent,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        textAlign: 'center',
        flexDirection: 'column',
        margin: '70px auto',
        maxWidth: '100%'
    },
    gridDesc: {
        width: '50%',
        minWidth: 700,
        maxWidth: '100%',
        margin: 'auto',
        position: 'relative',
        [theme.breakpoints.down("800")]: {
            minWidth: '100%',
        },
    },
    desc: {
        margin: 0,
        fontSize: 16,
    },
    gridBtns: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '25px',
        [theme.breakpoints.down("376")]: {
            flexDirection: 'column',
            width: '100%',
            '& > button': {
                width: '90%'
            },
            '& > a': {
                width: '90%'
            }
        },
    },
    BtnsPhone:{
        [theme.breakpoints.down("376")]: {
            '& > button': {
                width: '100%',
                margin: '5px 0px',
            }
        },
    },
    linkBtnRed: {
        '@media (max-width: 375px)': {
            width: '90%',
        },
    },
    btnRed: {
        margin: 5,
        '@media (max-width: 375px)': {
            width: '100%',
            margin: '5px 0px',
        },
    },
    btnWhite: {
        margin: 5,
        padding: '0px 33.5px',
    },
    line: {
        borderRadius: 3,
        height: 4,
        border: 'none',
        backgroundColor: theme.palette.light.type2,
        position: 'absolute',
        top: -10,
        right: 'calc(50% - 15px)',
        width: 30,
        [theme.breakpoints.down('1135')]: {
            top: -10,
            display: 'none'
        },
        [theme.breakpoints.down(responsiveLength)]: {
            top: -10,
            display: 'none'
        }
    },
    title: {
        fontSize: 30,
        whiteSpace: 'nowrap',
        fontWeight: 700,
        [theme.breakpoints.down('1500')]: {
            fontSize: 26,
        },
        [theme.breakpoints.down('500')]: {
            whiteSpace: 'normal',
            width: '90%',
            margin: 'auto',
            textAlign: 'center'
        }
    },
}))

export default function Index() {

    let classes = useStyles();

    return (
        <div className={classes['root']}>
            <div className={classes['gridDesc']}>
                <div className={classes['line']} />
                <h3 className={classes['title']}>
                    دریافت کد بورسی و مشاوره
                </h3>
                <p className={classes['desc']}>
                    شما می‌توانید به راحتی و به صورت رایگان، بدون نیاز به حضور شخصی، کد بورسی خود را از کارگزاری پویان دریافت کنید. همچنین، اگر نیاز به راهنمایی دارید، می‌توانید با تماس و مشاوره رایگان، از تخصصی‌ترین مشاوران سرمایه‌گذاری پویان بهره‌مند شوید.
                </p>


            </div>
            <div className={classes['gridBtns']}>
                <a href="https://reg.pouyanbroker.com/" target={'_blank'} className={classes['linkBtnRed']}>
                    <button type="" className={`${classes['btnRed']} btnPouyanRed`}>
                        دریافت کد بورسی
                    </button>
                </a>
                <a href="tel:02191005777" className={classes['BtnsPhone']} >
                    <button type="" className={`${classes['btnWhite']} btnPouyanWhite`}>
                        تماس و مشاوره
                    </button>
                </a>
            </div>
        </div>)
}
